import { render, staticRenderFns } from "./contentCourseLiveStart.vue?vue&type=template&id=3890e752&"
import script from "./contentCourseLiveStart.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports